import type { IAppointmentState } from '../types/appointment.types';

export const initialState: IAppointmentState = {
  // Create new appointment
  createNewAppointment: {
    autogenBookedSlot: null,
    autogenOrgUnit: null,
    errorResponse: null,
    isAcuteVideoConsult: null,
    isSingleOrganizationVcService: null,
    isAutogenMakeNew: false,
    isCalledTCURequest: false,
    isHSGAppointment: false,
    isHsgConsult: null,
    isPreApptCompleted: true,
    isTCUMakeNew: false,
    isUrtiConsult: false,
    selectedDateTime: null,
    selectedDoctor: null,
    selectedFvInstitution: null,
    selectedInstitutionCode: null,
    selectedLinkedSlots: null,
    selectedLocation: null,
    selectedServiceType: null,
    selectedSpecialty: null,
    selectedTCUMakeNewType: null,
    selectedTCUSlots: null,
    successResponse: null,
    tcuRequestId: null,
  },
  finalConfirmMessage: null,
  appointmentDateRange: null,
  hsgTcuRequestId: null,
  isHideQueueReminder: false,
  mregContactNoUpdatedQnos: [],
  mregSuccessErrText: null,
  mregTodayAppointment: null,
  preQuestionnaire: {
    answerQuestionnaireValue: null,
    currentNumberOfAddButton: {},
    currentQuestionIndex: 0,
    isShowButtonBackToSummary: false,
    questionnaireValue: null,
  },
  // Reschedule and book next
  rescheduleAndBookNext: {
    appointmentSubmit: null,
    linkedAppointmentSlotMap: {},
    selectedLinkedAppointment: null,
  },
  selectedAppointment: null,
  selectedSlot: null,
  systemParams: null,
  vcpPatientDetails: null,
};
